<template>
  <div
    class="relative inline-block"
    :title="
      !inStock && backInStock
        ? $t('back_in_stock_subscription_form.cta_button_label')
        : undefined
    "
    data-test-id="product-select-variant"
    @click="selectVariant"
  >
    <button
      class="relative min-h-0 p-2 text-base font-normal leading-none"
      :class="{
        'shadow-ring': isActive,
        'mr-4': !inStock && backInStock,
        'cursor-default': !inStock && !backInStock,
        'border-error': showError,
      }"
    >
      <span
        :class="{
          'opacity-65': !inStock,
        }"
        >{{ label }}</span
      >
    </button>
    <MailIcon
      v-if="!inStock && backInStock"
      class="absolute right-[.3rem] top-1/2 size-4 -translate-y-1/2 cursor-pointer bg-white opacity-65"
    />
  </div>
</template>

<script setup lang="ts">
import type { Variant } from '@scayle/storefront-nuxt'
import { isInStock } from '@scayle/storefront-nuxt'
import useUiState from '~/composables/ui/useUiState'
import MailIcon from '~/assets/icons/mail.svg'
import { getSizeLabel } from '#layers/base/types/variant'

const props = defineProps({
  variant: {
    type: Object as PropType<Variant>,
    default: () => {},
  },
  active: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  showError: {
    type: Boolean,
    default: false,
  },
})

const { backInStock } = useGlobalConfig()

const emit = defineEmits(['selectSize'])

const { setActiveVariant, activeVariant } = useUiState()

const isActive = computed((): boolean => {
  return props.active || activeVariant.value?.id === props.variant?.id
})

const label = computed((): string | undefined => {
  return getSizeLabel(props.variant)
})

const inStock = computed((): boolean => {
  return isInStock(props.variant)
})

const selectVariant = (): void => {
  if (!backInStock.value && !inStock.value) {
    return // feature is disabled
  }
  setActiveVariant(props.variant)
  emit('selectSize', props.variant)
}
</script>
